module.exports = __webpack_public_path__ + "static/media/produit-icon-black.59d10799.svg";